<template>
  <div class="pages-aboutUS">
    <div class="the-banner"></div>
    <div class="bgbox-white">
      <el-col :xs="{span:24}" :sm="{span:24}" :md="{span:20,offset:2}" :lg="{span:16,offset:4}">
        <div class="module1-conts">
          <div class="module-title">
            <span class="title-cn">公司介绍</span>
            <span class="title-en">COMPANY PROFILE</span>
          </div>
          <p>同迅科技创立于2010年，总部设立在湖南长沙，创立以来一直致力于降低中国互联网带宽成本、改善用户体验，为中国网络加速产业贡献一份力量。</p>
          <p>公司包含研发部、推广部、销售部、大客户部、客服部、技术部等六大部门，通过在网络优化、IT、互联网安全、企业组网等领域为客户提供有竞争力、解决方案与服务，目前已服务超过10000家大中小企业，业务范围已拓展至东南亚等地区，正持续为用户提供有效价值。</p>
          <div class="item-list">
            <el-col :xs="{span:12}" :sm="{span:12}" :md="{span:6}" :lg="{span:5,offset:2}">
              <div class="item">
                <img :src="require('@/assets/images/aboutUS-module1-1.png')" />
                <span>中国三大运营商</span>
                <span>技术服务合作商</span>
              </div>
            </el-col>
            <el-col :xs="{span:12}" :sm="{span:12}" :md="{span:6}" :lg="{span:5}">
              <div class="item">
                <img :src="require('@/assets/images/aboutUS-module1-2.png')" />
                <span>广电集团</span>
                <span>技术服务提供商</span>
              </div>
            </el-col>
            <el-col :xs="{span:12}" :sm="{span:12}" :md="{span:6}" :lg="{span:5}">
              <div class="item">
                <img :src="require('@/assets/images/aboutUS-module1-3.png')" />
                <span>大型连锁、跨国</span>
                <span>企业技术服务商</span>
              </div>
            </el-col>
            <el-col :xs="{span:12}" :sm="{span:12}" :md="{span:6}" :lg="{span:5}">
              <div class="item">
                <img :src="require('@/assets/images/aboutUS-module1-4.png')" />
                <span>全光网络方案</span>
                <span>酒店联盟机构</span>
              </div>
            </el-col>
          </div>
          <div class="img-list">
            <el-row :gutter="20">
              <el-col :xs="{span:24}" :sm="{span:8}" :md="{span:8}" :lg="{span:6}">
                <div class="img-item">
                  <img :src="require('@/assets/images/aboutUS-module1-1.jpg')" />
                </div>
              </el-col>
              <el-col :xs="{span:24}" :sm="{span:8}" :md="{span:8}" :lg="{span:18}">
                <div class="img-item">
                  <img :src="require('@/assets/images/aboutUS-module1-2.jpg')" />
                </div>
              </el-col>
              <el-col :xs="{span:24}" :sm="{span:8}" :md="{span:8}" :lg="{span:6}">
                <div class="img-item">
                  <img :src="require('@/assets/images/aboutUS-module1-3.jpg')" />
                </div>
              </el-col>
              <el-col :xs="{span:24}" :sm="{span:8}" :md="{span:8}" :lg="{span:6}">
                <div class="img-item">
                  <img :src="require('@/assets/images/aboutUS-module1-4.jpg')" />
                </div>
              </el-col>
              <el-col :xs="{span:24}" :sm="{span:8}" :md="{span:8}" :lg="{span:6}">
                <div class="img-item">
                  <img :src="require('@/assets/images/aboutUS-module1-5.jpg')" />
                </div>
              </el-col>
              <el-col :xs="{span:24}" :sm="{span:8}" :md="{span:8}" :lg="{span:6}">
                <div class="img-item">
                  <img :src="require('@/assets/images/aboutUS-module1-6.jpg')" />
                </div>
              </el-col>
            </el-row>
          </div>
        </div>
      </el-col>
    </div>
    <div class="bgbox-img">
      <el-col :xs="{span:24}" :sm="{span:24}" :md="{span:20,offset:2}" :lg="{span:16,offset:4}">
        <div class="module2-conts">
          <div class="module-title">
            <span class="title-cn">经营范围</span>
            <span class="title-en">BUSINESS SCOPE</span>
          </div>
          <el-col :xs="{span:24}" :sm="{span:24}" :md="{span:9}" :lg="{span:9}">
            <div class="conts-list">
              <p class="line1">30<span>省</span></p>
              <p class="line2">业务覆盖中国30个省</p>
              <p class="line1">20<span>国家</span></p>
              <p class="line2">业务拓展到东南亚,越南、泰国、老挝、印尼、柬埔寨、菲律宾、中东、欧美、日韩、法国、瑞士、英国</p>
              <p class="line1">10000+<span>家</span></p>
              <p class="line2">服务于10000多家中小大型企业和机构</p>
              
            </div>
          </el-col>
          <el-col :xs="{span:24}" :sm="{span:24}" :md="{span:15}" :lg="{span:15}">
            <div class="conts-img">
              <img :src="require('@/assets/images/aboutUS-module2.png')" />
            </div>
          </el-col>
        </div>
      </el-col>
    </div>
    <div class="bgbox-white">
      <el-col :xs="{span:24}" :sm="{span:24}" :md="{span:20,offset:2}" :lg="{span:16,offset:4}">
        <div class="module3-conts">
          <div class="module-title">
            <span class="title-cn">发展历程</span>
            <span class="title-en">DEVELOPMENT</span>
          </div>
          
          
        </div>
      </el-col>
    </div>
    <div class="fzlc">
          </div>
    <div class="bgbox-white">
      <el-col :xs="{span:24}" :sm="{span:24}" :md="{span:20,offset:2}" :lg="{span:16,offset:4}">
        <div class="module4-conts">
          <div class="module-title">
            <span class="title-cn">我们的信仰</span>
            <span class="title-en">OUR FAITH</span>
          </div>
          <el-col :xs="{span:24}" :sm="{span:24}" :md="{span:24}" :lg="{span:8}">
            <div class="module4-item wow slideInLeft">
              <div class="conts">
                <img :src="require('@/assets/images/aboutUS-module4-1.jpg')" />
                <h3>使命和愿景</h3>
                <p>降低中国互联网带宽成本、改善用户体验，为中国网络加速产业贡献力量。</p>
              </div>
            </div>
          </el-col>
          <el-col :xs="{span:24}" :sm="{span:12}" :md="{span:12}" :lg="{span:8}">
            <div class="module4-item wow slideInUp">
              <div class="conts">
                <img :src="require('@/assets/images/aboutUS-module4-2.jpg')" />
                <h3>技术与研发</h3>
                <p>同迅科技聚焦网络加速技术，Xspeeder引擎和SD-WAN技术，将给用户带来更丰富的使用场景。</p>
              </div>
            </div>
          </el-col>
          <el-col :xs="{span:24}" :sm="{span:12}" :md="{span:12}" :lg="{span:8}">
            <div class="module4-item wow slideInRight">
              <div class="conts">
                <img :src="require('@/assets/images/aboutUS-module4-3.jpg')" />
                <h3>合作、发展、共赢</h3>
                <p>与合作伙伴一起建立“互惠、共生、发展”的产业环境和共赢繁荣的商业生态体系。</p>
              </div>
            </div>
          </el-col>
        </div>
      </el-col>
    </div>
    <div class="bgbox-white">
      <el-col :xs="{span:24}" :sm="{span:24}" :md="{span:20,offset:2}" :lg="{span:16,offset:4}">
        <div class="module5-conts">
          <div class="module-title">
            <span class="title-cn">公司资质</span>
            <span class="title-en">COMPANY QUALIFICATION</span>
          </div>
          <div class="project-box wow zoomIn">
            <el-col class="company-certify" :xs="{span:24}">
              <swiper :options="swiperOptionCompany">
                <!-- slides -->
                <swiper-slide><img :src="require('@/assets/images/index-company1.jpg')" /></swiper-slide>
                <swiper-slide><img :src="require('@/assets/images/index-company2.jpg')" /></swiper-slide>
                <swiper-slide><img :src="require('@/assets/images/index-company3.jpg')" /></swiper-slide>
                <swiper-slide><img :src="require('@/assets/images/index-company4.jpg')" /></swiper-slide>
                <!-- Optional controls -->
                <div class="swiper-button-prev swiper-company-button-prev" slot="button-prev"></div>
                <div class="swiper-button-next swiper-company-button-next" slot="button-next"></div>
              </swiper>
            </el-col>
          </div>
        </div>
      </el-col>
    </div>
    <div class="bgbox-white">
      <el-col :xs="{span:24}" :sm="{span:24}" :md="{span:20,offset:2}" :lg="{span:16,offset:4}">
        <div class="module6-conts">
          <div class="module-title">
            <span class="title-cn">公司风采</span>
            <span class="title-en">COMPANY ELEGANT DEMEANOR</span>
          </div>
          <div class="title">
            <span>行业交流</span>
          </div>
          <div class="img-box wow slideInUp">
            <el-row :gutter="12">
              <el-col :xs="{span:24}" :sm="{span:8}">
                <div class="img-item" data-wow-duration="1s" data-wow-delay="0.1s">
                  <img :src="require('@/assets/images/aboutUS-module6-1.jpg')" />
                  <div class="info">SD-WAN峰会</div>
                </div>
              </el-col>
              <el-col :xs="{span:24}" :sm="{span:8}">
                <div class="img-item" data-wow-duration="1s" data-wow-delay="0.2s">
                  <img :src="require('@/assets/images/aboutUS-module6-2.jpg')" />
                  <div class="info">全光网络交流会议</div>
                </div>
              </el-col>
              <el-col :xs="{span:24}" :sm="{span:8}">
                <div class="img-item" data-wow-duration="1s" data-wow-delay="0.3s">
                  <img :src="require('@/assets/images/aboutUS-module6-3.jpg')" />
                  <div class="info">同迅科技接受电视台采访</div>
                </div>
              </el-col>
            </el-row>
          </div>
          <div class="title">
            <span>团队风采</span>
          </div>
          <div class="img-box wow slideInUp">
            <el-row :gutter="12">
              <el-col :xs="{span:24}" :sm="{span:8}">
                <div class="img-item" data-wow-duration="1s" data-wow-delay="0.1s">
                  <img :src="require('@/assets/images/aboutUS-module6-4.jpg')" />
                  <div class="info">2019年年终总结</div>
                </div>
              </el-col>
              <el-col :xs="{span:24}" :sm="{span:8}">
                <div class="img-item" data-wow-duration="1s" data-wow-delay="0.2s">
                  <img :src="require('@/assets/images/aboutUS-module6-5.jpg')" />
                  <div class="info">“和道源”农家乐活动</div>
                </div>
              </el-col>
              <el-col :xs="{span:24}" :sm="{span:8}">
                <div class="img-item" data-wow-duration="1s" data-wow-delay="0.3s">
                  <img :src="require('@/assets/images/aboutUS-module6-6.jpg')" />
                  <div class="info">公司内羽毛球比赛</div>
                </div>
              </el-col>
            </el-row>
          </div>
          <div class="img-box wow slideInUp">
            <el-row :gutter="12">
              <el-col :xs="{span:24}" :sm="{span:8}">
                <div class="img-item" data-wow-duration="1s" data-wow-delay="0.1s">
                  <img :src="require('@/assets/images/aboutUS-module6-7.jpg')" />
                  <div class="info">广州国际酒店用品展</div>
                </div>
              </el-col>
              <el-col :xs="{span:24}" :sm="{span:8}">
                <div class="img-item" data-wow-duration="1s" data-wow-delay="0.2s">
                  <img :src="require('@/assets/images/aboutUS-module6-8.jpg')" />
                  <div class="info">江西明月山两日游</div>
                </div>
              </el-col>
              <el-col :xs="{span:24}" :sm="{span:8}">
                <div class="img-item" data-wow-duration="1s" data-wow-delay="0.3s">
                  <img :src="require('@/assets/images/aboutUS-module6-9.jpg')" />
                  <div class="info">公司年终聚餐</div>
                </div>
              </el-col>
            </el-row>
          </div>
        </div>
      </el-col>
    </div>
    <div class="bgbox-white">
      <el-col :xs="{span:24}" :sm="{span:24}" :md="{span:20,offset:2}" :lg="{span:20,offset:2}">
        <div class="module7-conts">
          <div class="module-title">
            <span class="title-cn">公司地址</span>
            <span class="title-en">COMPANY ADDRESS</span>
          </div>
          <div class="map-box">
            <baidu-map class="bm-view" :center="center" :zoom="zoom" ak="2864FMW4Ct3sCOoin07oxvK8XFPaAPTm" @ready="maphandler">
              <bm-marker :position="center" :dragging="false" animation="BMAP_ANIMATION_BOUNCE">
                <bm-label content="同迅科技有限公司" />
                <bm-navigation anchor="BMAP_ANCHOR_TOP_RIGHT"></bm-navigation>
              </bm-marker>
            </baidu-map>
          </div>
        </div>
      </el-col>
    </div>
    <el-dialog :visible.sync="showBigImg" :center="true" :show-close="false" custom-class="dialog-bigimg">
      <img :src="bigImgSrc" />
    </el-dialog>
  </div>
</template>

<script>
import 'swiper/dist/css/swiper.css'
import { swiper, swiperSlide } from 'vue-awesome-swiper'
import BaiduMap from 'vue-baidu-map/components/map/Map.vue'
import BmMarker from 'vue-baidu-map/components/overlays/Marker'
import BmLabel from 'vue-baidu-map/components/overlays/Label'
import BmNavigation from 'vue-baidu-map/components/controls/Navigation'

export default {
  components: {
    swiper,
    swiperSlide,
    BaiduMap,
    BmMarker,
    BmLabel,
    BmNavigation
  },
  data() {
    let vm = this
    return {
      showBigImg: false,
      bigImgSrc:null,
      swiperOptionCompany: {
        slidesPerView: 4,//显示数量
        spaceBetween: 20,
        centeredSlides: true,
        loop: true,
        autoplay:{
          delay: 5000,
          disableOnInteraction: false//点击切换后 停止继续自动播放
        },
        breakpoints: {
          640: {
            slidesPerView: 1,
            spaceBetween: 0,
          },
          768: {
            slidesPerView: 4,
            spaceBetween: 30,
          }
        },
        navigation: {
          nextEl: '.swiper-company-button-next',
          prevEl: '.swiper-company-button-prev',
        },
        on:{
          click:function(){
            if(this.clickedSlide){
              vm.bigImgSrc = this.clickedSlide.getElementsByTagName('img')[0].getAttribute('src');
              vm.showBigImg = true;
              // console.log(this.clickedSlide.getAttribute('data-swiper-slide-index'));
              // console.log(this);
            }
          }
        }
      },
      center: {lng: 0, lat: 0},
      zoom: 3
    };
  },
  methods: {
    maphandler(){
      this.center.lng = 113.041659
      this.center.lat = 28.164485
      this.zoom = 18
    }
  }
};
</script>
<style lang="scss">
.join_us{
    display: block;
    width: 33%;
    max-width: 1920px;
    margin: 0 auto;
}

.BMap_cpyCtrl, .anchorBL {
  display: none;
}
.BMapLabel{
  padding: 6px !important;
  border: 1px solid #0066cc !important;
  color: #0066cc !important;
  left: -45px !important;
  top: -30px !important;
  font-weight: bold !important;
}
// big img
.dialog-bigimg{
  box-shadow: none;
  background: transparent;
  margin: 5% auto 0 !important;
  width: fit-content !important;
  height: auto !important;
  overflow: hidden;
  .el-dialog__header{
    display: none;
  }
  .el-dialog__body{
    padding: 0;
    width: fit-content !important;
    height: auto !important;
    img{
      max-width: 100%;
      max-height: 100%;
      margin: 0 auto;
      display: block;
    }
  }
}
</style>
<style lang="scss" scoped>
.bgbox-white{
  padding: 50px 10px;
  overflow: hidden;
  background: #fff;
  box-sizing: border-box;
}
.fzlc {
  margin-top: -200px;
  zoom: 70%;
  height: 1080px;
  background-image: url("../../assets/images/fzlc.png");
  background-repeat: no-repeat;
  background-position: center;
}

.the-banner {
  height: 400px;
  background-image: url("../../assets/images/aboutUS-banner1.jpg");
  background-repeat: no-repeat;
  background-position: center;
}
.module-title{
  text-align: center;
  padding-bottom: 40px;
  .title-cn{
    display: block;
    font-size: 30px;
    font-weight: bold;
    color: #1f1f1f;
  }
  .title-en{
    display: block;
    font-size: 12px;
    font-weight: 400;
    color: #757575;
    line-height: 20px;
  }
}
.module1-conts{
  p{
    font-size: 14px;
    color: #1f1f1f;
    text-indent: 2em;
  }
  .item-list{
    width: 100%;
    padding: 40px 0;
    box-sizing: border-box;
    overflow: hidden;
    .item{
      width: 120px;
      margin: 0 auto;
      text-align: center;
      padding: 20px 0;
      box-sizing: border-box;
      img{
        display: inline-block;
        margin-bottom: 16px;
      }
      span{
        display: block;
        font-size: 14px;
        color: #1f1f1f;
      }
    }
  }
  .img-list{
    max-width: 1220px;
    margin: 0 auto;
    overflow: hidden;
    .img-item{
      width: 100%;
      height: 160px;
      overflow: hidden;
      margin-bottom: 20px;
      img{
        display: block;
        height: 100%;
        margin: 0 auto;
      }
    }
  }
}

.bgbox-img{
  padding: 50px 10px;
  overflow: hidden;
  background-image: url("../../assets/images/aboutUS-module2bg.jpg");
  background-position: center center;
  box-sizing: border-box;
  .module-title{
    text-align: center;
    padding-bottom: 40px;
    .title-cn{
      display: block;
      font-size: 30px;
      font-weight: bold;
      color: #ffffff;
    }
    .title-en{
      display: block;
      font-size: 12px;
      font-weight: 400;
      color: #ffffff;
      line-height: 20px;
    }
  }
  .module2-conts{
    overflow: hidden;
    .conts-list{
      padding: 20px 0 0 20px;
      text-align: left;
      .line1{
        font-size: 35px;
        color: #0066cc;
        span{
          font-size: 16px;
          color: #fff;
        }
      }
      .line2{
        font-size: 16px;
        color: #fff;
        margin-bottom: 20px;
      }
    }
    .conts-img{
      padding: 20px 0;
      text-align: center;
      img{
        width: 100%;
        max-width: 410px;
      }
    }
  }
}

.module3-conts{
  overflow: hidden;
  .step-item{
    width: 100%;
    height: 440px;
    position: relative;
    &::before{
      content: '';
      height: 2px;
      width: 100%;
      background: #e6e6e6;
      position: absolute;
      top: 50%;
      transform: translateY(-50%);
    }
    .top{
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      bottom: 221px;
      &::before{
        content: '';
        width: 10px;
        height: 10px;
        background: #0066cc;
        border-radius: 50%;
        position: absolute;
        left: 50%;
        transform: translateX(-50%);
        bottom: -6px;
      }
      &::after{
        content: '';
        width: 2px;
        height: 120px;
        border: 1px dashed #0066cc;
        box-sizing: border-box;
        position: absolute;
        left: 50%;
        transform: translateX(-50%);
        bottom: 0;
      }
      .conts{
        background: #fff;
        padding: 0 10px;
        box-sizing: border-box;
        position: absolute;
        z-index: 9;
        padding-bottom: 10px;
        h5{
          font-size: 16px;
          color: #0066cc;
          text-align: center;
          margin-bottom: 10px;
        }
        p{
          font-size: 14px;
          color: #1f1f1f;
        }
      }
      h6{
        font-size: 16px;
        color: #1f1f1f;
        position: absolute;
        bottom: -30px;
        left: 50%;
        transform: translateX(-50%);
      }
    }
    .down{
      position: absolute;
      top: 221px;
      left: 0;
      width: 100%;
      bottom: 0;
      &::before{
        content: '';
        width: 10px;
        height: 10px;
        background: #0066cc;
        border-radius: 50%;
        position: absolute;
        left: 50%;
        transform: translateX(-50%);
        top: -6px;
      }
      &::after{
        content: '';
        width: 2px;
        height: 120px;
        border: 1px dashed #0066cc;
        box-sizing: border-box;
        position: absolute;
        left: 50%;
        transform: translateX(-50%);
        top: 0;
      }
      .conts{
        background: #fff;
        padding: 0 10px;
        box-sizing: border-box;
        position: absolute;
        bottom: 0;
        z-index: 9;
        padding-top: 10px;
        h5{
          font-size: 16px;
          color: #0066cc;
          text-align: center;
          margin-bottom: 10px;
        }
        p{
          font-size: 14px;
          color: #1f1f1f;
        }
      }
      h6{
        font-size: 16px;
        color: #1f1f1f;
        position: absolute;
        top: -30px;
        left: 50%;
        transform: translateX(-50%);
      }
    }
  }
}

.module4-conts{
  overflow: hidden;
  .module4-item{
    max-width: 380px;
    margin: 0 auto;
    padding: 10px;
    box-sizing: border-box;
    .conts{
      padding: 20px;
      box-sizing: border-box;
      background: #f5f5f5;
      min-height: 400px;
      transition: all 0.3s ease-in;
      &:hover{
        box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
        transform: translate3d(0,-2px,0);
        background: rgba(124, 215, 243, 0.2);
        img{
          transform: scale(1.06);
        }
      }
      img{
        transition: all 0.3s ease-out;
        width: 100%;
      }
      h3{
        font-size: 18px;
        color: #1f1f1f;
        line-height: 60px;
        border-bottom: 1px solid #e6e6e6;
      }
      p{
        font-size: 14px;
        color: #1f1f1f;
        padding: 20px 0;
      }
    }
  }
}

.module5-conts{
  .project-box{
    overflow: hidden;
    width: 100%;
    box-sizing: border-box;
    .company-certify{
      height: auto;
      .swiper-container {
        width: 100%;
        height: 100%;
        &::before{
          content:"";
          width: 12%;
          height: 100%;
          background: linear-gradient(right, rgba(255,255,255,0) , rgba(255,255,255,1));
          position: absolute;
          left: 0;
          top: 0;
          z-index: 9;
        }
        &::after{
          content:"";
          width: 12%;
          height: 100%;
          background: linear-gradient(left, rgba(255,255,255,0) , rgba(255,255,255,1));
          position: absolute;
          right: 0;
          top: 0;
          z-index: 9;
        }
      }
      .swiper-slide{
        height: 100%;
        text-align: center;
      }
      .swiper-slide img{
        max-width: 100%;
        max-height: 400px;
        border: 1px solid #eee;
        box-sizing: border-box;
        cursor: pointer;
      }
      .swiper-button-prev,.swiper-button-next{
        outline: none;
        height: 30px;
      }
    }
  }
}

.module6-conts{
  .title{
    height: 60px;
    line-height: 60px;
    span{
      font-size: 18px;
      color: #1f1f1f;
      font-weight: bold;
    }
  }
  .img-box{
    .img-item{
      margin-bottom: 20px;
      position: relative;
      overflow: hidden;
      .info{
        position: absolute;
        left: 0;
        width: 100%;
        bottom: 0;
        height: 40px;
        line-height: 40px;
        background: rgba($color: #000000, $alpha: 0.6);
        color: #fff;
        font-size: 16px;
        padding-left: 10px;
        box-sizing: border-box;
      }
      img{
        cursor: pointer;
        vertical-align: middle;
        width: 100%;
        transition: all 0.5s ease;
        &:hover{
          transform: scale(1.05);
        }
      }
    }
  }
}

.module7-conts{
  .map-box{
    height: 500px;
    overflow: hidden;
    .bm-view {
      width: 100%;
      height: 100%;
    }
  }
}




// 移动端css
@media screen and (max-width: 767px) {
  .the-banner{
    height: 260px;
    background-image: url("../../assets/images/aboutUS-banner2.jpg");
  }
  .module4-conts{
    .module4-item{
      padding: 10px 0;
    }
  }
}
</style>